import { render, staticRenderFns } from "./CustomerApprovals.vue?vue&type=template&id=1d8c7e20&"
import script from "./CustomerApprovals.vue?vue&type=script&lang=js&"
export * from "./CustomerApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports